import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Afdelinger, Grupper, IndexCards } from './IndexCards';
import { Titler } from './IndexCards';

@Injectable({ providedIn: 'root' })
export class IndexCardsService {

    constructor(private http: HttpClient) { }

    getAllByOffice(): Observable<IndexCards[]> {
        const url = `[api]/model/indexcard/allByOffice/[officeId]`;
        return this.http.get<IndexCards[]>(url);
    }

    getAllTitler(): Observable<Titler[]> {
        const url = `[api]/model/titler/allTitler`;
        return this.http.get<Titler[]>(url);
    }

    getAllAfdelinger(): Observable<Afdelinger[]> {
        const url = `[api]/medarbejdere/afdelinger/[officeId]`;
        return this.http.get<Afdelinger[]>(url);
    }

    getAllGrupper(): Observable<Grupper[]> {
        const url = `[api]/medarbejdere/grupper/[officeId]`;
        return this.http.get<Grupper[]>(url);
    }

    updateIndexCard<T extends keyof IndexCards>(
        cardId: number,
        key: T,
        value: IndexCards[T]
    ): Observable<IndexCards> {
        const url = `[api]/model/indexcard/update/${cardId}`;

        const patchDoc = [{
            op: 'replace',
            path: `/${String(key)}`,
            value: value
        }];

        return this.http.patch<IndexCards>(url, patchDoc);
    }

    deleteGruppe(gruppeId: number): Observable<Grupper[]> {
        const url = `[api]/medarbejdere/grupper/delete/${gruppeId}`;
        return this.http.delete<Grupper[]>(url);
    }

    deleteAfdeling(afdelingId: number): Observable<Afdelinger[]> {
        const url = `[api]/medarbejdere/afdelinger/delete/${afdelingId}`;
        return this.http.delete<Afdelinger[]>(url);
    }

    createAfdeling(afdelingString: string): Observable<Afdelinger> {
        const url = `[api]/medarbejdere/afdelinger/create/[officeId]/${afdelingString}`;
        return this.http.post<Afdelinger>(url, {});
    }

    createGruppe(gruppeString: string): Observable<Grupper> {
        const url = `[api]/medarbejdere/grupper/create/[officeId]/${gruppeString}`;
        return this.http.post<Grupper>(url, {});
    }

}
